import { fetcher } from '@commenda/utils';
import {
  IIndirectTaxCloseRegistrationV2Params,
  IIndirectTaxUpdateRegistrationV2Response,
} from './types';

export async function closeIndirectTaxRegistration(
  registrationId: string,
  corporationId: number,
  body: IIndirectTaxCloseRegistrationV2Params
): Promise<{
  success: boolean;
  data?: IIndirectTaxUpdateRegistrationV2Response;
  error?: string;
}> {
  try {
    const query = new URLSearchParams();
    query.append('corporationId', corporationId?.toString());

    const response = await fetcher(
      `new-sales-tax/registrations-v2/${registrationId}/close?${query}`,
      { method: 'POST', body },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to close registration',
      };
    }

    const data: IIndirectTaxUpdateRegistrationV2Response = await response.json();
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to close registration';
    return { success: false, error: errorMessage };
  }
}
